import { PerformanceMonitor } from '@react-three/drei'
import type { QualidadeAdaptativa } from './useQualidadeAdaptativa'

/**
 * Faixa de taxa de quadros considerada saudável: abaixo do piso a qualidade
 * cai, acima do teto ela pode subir de novo. O teto fica um pouco abaixo de
 * 60 porque um monitor de 60 Hz não passa de ~60 e a média de uma janela
 * raramente encosta nesse valor. Telas de 120/144 Hz têm uma faixa própria.
 */
const limitesDeQuadros = (taxaDaTela: number): [number, number] =>
  taxaDaTela > 100 ? [60, 100] : [40, 55]

/**
 * Mede a taxa de quadros dentro do `<Canvas>` e repassa o que viu a
 * `useQualidadeAdaptativa`. Não usa `flipflops` do drei: ao estourar o limite
 * ele interrompe a medição para sempre, e numa máquina boa isso aconteceria em
 * segundos — a qualidade nunca mais reagiria a uma cena pesada. O teto de
 * trocas fica no redutor (`reduzirQualidade`), que continua ouvindo.
 */
export function MonitorQualidade({
  adaptativa,
  aoDecair,
  aoSubir,
}: Pick<QualidadeAdaptativa, 'adaptativa' | 'aoDecair' | 'aoSubir'>) {
  if (!adaptativa) return null
  return <PerformanceMonitor bounds={limitesDeQuadros} onDecline={aoDecair} onIncline={aoSubir} />
}
